import { render, staticRenderFns } from "./Riparazioni.vue?vue&type=template&id=1aa8b0f5"
import script from "./Riparazioni.vue?vue&type=script&lang=js"
export * from "./Riparazioni.vue?vue&type=script&lang=js"
import style0 from "./Riparazioni.vue?vue&type=style&index=0&id=1aa8b0f5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports